import type { DiscoveryFilter } from "../../types/filters/common";
import { MarketingNarrativesFilterField } from "../../types/filters/marketingNarratives";

export const marketingNarrativesFilters: DiscoveryFilter[] = [
    {
        label: "Marketplace",
        field: MarketingNarrativesFilterField.MARKETPLACE,
        isAdditional: true,
    },
    {
        label: "Language",
        field: MarketingNarrativesFilterField.LANGUAGE,
        isAdditional: true,
    },
    {
        label: "Vertical",
        field: MarketingNarrativesFilterField.VERTICAL,
        isAdditional: true,
    },
    {
        label: "Sub Vertical",
        field: MarketingNarrativesFilterField.SUBVERTICAL,
        isAdditional: true,
    },
    {
        label: "Ad activation channel",
        field: MarketingNarrativesFilterField.AD_ACTIVATION_CHANNEL,
        isAdditional: true,
    },
    {
        label: "Ad products and formats",
        field: MarketingNarrativesFilterField.AD_PRODUCTS_AND_FORMATS,
        isAdditional: true,
    },
    {
        label: "Primary content creator team",
        field: MarketingNarrativesFilterField.PRIMARY_CONTENT_CREATOR_TEAM,
        isAdditional: true,
    },
    {
        label: "Marketing strategy",
        field: MarketingNarrativesFilterField.MARKETING_STRATEGY,
        isAdditional: true,
    },
    {
        label: "Seasonal events",
        field: MarketingNarrativesFilterField.SEASONAL_EVENTS,
        isAdditional: true,
    },
    {
        label: "Advertiser goal",
        field: MarketingNarrativesFilterField.ADVERTISER_GOAL,
        isAdditional: true,
    },
    {
        label: "File Type",
        field: MarketingNarrativesFilterField.FILE_TYPE,
        isAdditional: true,
    },
];
